import { gql } from '__generated__'
import type { GetCandidateProfileForRecruiterQuery } from '__generated__/graphql'

export type CandidateNote = NonNullable<
    NonNullable<GetCandidateProfileForRecruiterQuery['candidate']>['notes']
>[number]

export const PinCandidateNote = gql(/* GraphQL */ `
    mutation PinCandidateNoteMutation($noteId: String!) {
        toggleCandidateNotePin(noteId: $noteId) {
            success
            message
        }
    }
`)

export const AddCandidateNote = gql(/* GraphQL */ `
    mutation AddCandidateNote(
        $candidateId: ID!
        $templateId: ID!
        $note: String
        $starRating: Float
        $excludeFromEvaluation: Boolean
        $companyId: ID
        $rosterId: ID
    ) {
        addCandidateNote(
            candidateId: $candidateId
            templateId: $templateId
            note: $note
            starRating: $starRating
            excludeFromEvaluation: $excludeFromEvaluation
            companyId: $companyId
            rosterId: $rosterId
        ) {
            success
            message
        }
    }
`)

export const UpdateCandidateNote = gql(/* GraphQL */ `
    mutation UpdateCandidateNote(
        $candidateId: ID!
        $templateId: ID!
        $noteId: ID!
        $note: String
        $starRating: Float
        $excludeFromEvaluation: Boolean
        $companyId: ID
        $rosterId: ID
    ) {
        updateCandidateNote(
            candidateId: $candidateId
            templateId: $templateId
            note: $note
            starRating: $starRating
            noteId: $noteId
            excludeFromEvaluation: $excludeFromEvaluation
            companyId: $companyId
            rosterId: $rosterId
        ) {
            success
            message
        }
    }
`)

export const DeleteCandidateNote = gql(/* GraphQL */ `
    mutation DeleteCandidateNote($noteId: String!) {
        deleteCandidateNote(noteId: $noteId) {
            success
            message
        }
    }
`)

export const GetCandidateNoteTemplates = gql(/* GraphQL */ `
    query GetCandidateNoteTemplates {
        noteTemplates {
            templateType
            id
            hasStarRating
            starRatingRequired
            isScreeningType
            canCreate
            canDelete
            canEdit
            template
        }
    }
`)
